import type { BatchUpdateListingLoanFeeDTO } from 'app/network/listing';
import * as yup from 'yup';

export const schema: yup.ObjectSchema<BatchUpdateListingLoanFeeDTO> = yup.object().shape({
  loanFee: yup.number().nullable().defined(),
  loanFeeDescription: yup.string().nullable().defined(),
  loanFeePaymentMethod: yup.string().nullable().defined(),
  loanFeeDocument: yup.string().nullable().optional(),
});
